import TrainingPage from "../components/training/main";

const Training = () => {
  return <TrainingPage />;
};

export default Training;
